/* LIMTEH trust: review slider + free-delivery bar + delivery estimate. Added by Manager build, Oct 2026. */
(function () {
  function initSliders(root) {
    (root || document).querySelectorAll('[data-lt-slider]').forEach(function (s) {
      if (s.dataset.ltInit) return; s.dataset.ltInit = '1';
      var t = s.querySelector('[data-lt-track]'); if (!t) return;
      var dots = s.querySelector('[data-lt-dots]');
      function pages() { return Math.max(1, Math.ceil((t.scrollWidth - 4) / t.clientWidth)); }
      function render() {
        var n = pages(), cur = Math.min(n - 1, Math.round(t.scrollLeft / t.clientWidth));
        s.classList.toggle('lt-gr--single', n <= 1);
        if (!dots) return; dots.innerHTML = '';
        for (var i = 0; i < n; i++) (function (i) {
          var b = document.createElement('button'); b.type = 'button';
          b.className = 'lt-gr__dot' + (i === cur ? ' is-on' : '');
          b.setAttribute('aria-label', 'Show reviews ' + (i + 1));
          b.addEventListener('click', function () { t.scrollTo({ left: i * t.clientWidth, behavior: 'smooth' }); });
          dots.appendChild(b);
        })(i);
      }
      var p = s.querySelector('[data-lt-prev]'), nx = s.querySelector('[data-lt-next]');
      if (p) p.addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth, behavior: 'smooth' }); });
      if (nx) nx.addEventListener('click', function () { t.scrollBy({ left: t.clientWidth, behavior: 'smooth' }); });
      var tm; t.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(render, 80); }, { passive: true });
      window.addEventListener('resize', render); render();
    });
  }
  function money(c) {
    try { return theme.Currency.formatMoney(c, theme.settings.moneyFormat); } catch (e) { return 'S$' + (c / 100).toFixed(2); }
  }
  function update(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-lt-ship]').forEach(function (el) {
      var th = parseInt(el.dataset.threshold, 10) || 5000;
      if (el.dataset.currency && cart.currency && cart.currency !== el.dataset.currency) { el.hidden = true; return; }
      el.hidden = !cart.item_count;
      var left = th - cart.total_price;
      var fill = el.querySelector('[data-lt-ship-fill]'), msg = el.querySelector('[data-lt-ship-msg]');
      if (fill) fill.style.width = Math.max(0, Math.min(100, cart.total_price / th * 100)) + '%';
      if (msg) msg.innerHTML = left > 0 ? el.dataset.msgLeft.replace('[amount]', '<b>' + money(left) + '</b>') : el.dataset.msgDone;
      el.classList.toggle('is-done', left <= 0);
    });
    renderRecs(cart);
    renderCartEta(cart);
  }

  /* ---- Delivery estimate (Singapore time, working days Mon-Fri minus public holidays) ---- */
  function etaCfg() {
    var el = document.querySelector('[data-lt-eta-config]'); if (!el) return null;
    try { var c = JSON.parse(el.textContent); } catch (e) { return null; }
    c.holidays = String(c.hol || '').split(/\n/).map(function (l) { return (l.match(/\d{4}-\d{2}-\d{2}/) || [])[0]; }).filter(Boolean);
    c.peakMonths = String(c.peak || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; });
    return c;
  }
  function sgNow() {
    var p = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Singapore', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { d: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), h: +p.hour, m: +p.minute };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function isWork(d, c) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && c.holidays.indexOf(iso(d)) < 0; }
  function addWork(d, n, c) { d = new Date(d); while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (isWork(d, c)) n--; } return d; }
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function dayStr(d) { return WD[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + MO[d.getUTCMonth()]; }
  function rangeStr(a, b) {
    /* "Tue 6 to Fri 9 Oct"; across months "Fri 30 Oct to Tue 3 Nov" (KK: no dashes) */
    var left = WD[a.getUTCDay()] + ' ' + a.getUTCDate() + (a.getUTCMonth() === b.getUTCMonth() ? '' : ' ' + MO[a.getUTCMonth()]);
    return left + ' to ' + WD[b.getUTCDay()] + ' ' + b.getUTCDate() + ' ' + MO[b.getUTCMonth()];
  }
  function estimate(c) {
    var n = sgNow(), start = n.d, today = isWork(n.d, c) && n.h < c.cut;
    if (!today) start = addWork(n.d, 1, c);
    var peak = c.peakMonths.indexOf(start.getUTCMonth() + 1) > -1;
    return { today: today, start: start, peak: peak, from: addWork(start, c.min, c), to: addWork(start, c.max + (peak ? c.extra : 0), c) };
  }
  var CLOCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  function renderEta() {
    var c = etaCfg(); if (!c) return;
    var n = sgNow(), e = estimate(c);
    document.querySelectorAll('[data-lt-eta]').forEach(function (box) {
      var st = box.querySelector('[data-lt-eta-start]'); if (st) st.textContent = dayStr(n.d);
      box.querySelector('[data-lt-eta-range]').textContent = rangeStr(e.from, e.to);
      var pk = box.querySelector('[data-lt-eta-peak]'); if (pk) pk.hidden = !(e.peak && c.extra > 0);
      var cd = box.querySelector('[data-lt-eta-cd]');
      if (cd) {
        if (e.today) {
          var left = Math.max(1, c.cut * 60 - (n.h * 60 + n.m)), hh = Math.floor(left / 60), mm = left % 60;
          cd.className = 'lt-tc__cd';
          cd.innerHTML = CLOCK + '<span>Order within <b>' + (hh ? hh + 'h ' : '') + mm + 'm</b> to start processing today</span>';
        } else {
          cd.className = 'lt-tc__cd'; cd.innerHTML = '';
        }
      }
      box.hidden = false;
    });
    return e;
  }
  var tagCache = {};
  function isPre(item, c) {
    var h = item.handle; if (!h) return Promise.resolve(false);
    if (!tagCache[h]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      tagCache[h] = fetch(root + 'products/' + h + '.js').then(function (r) { return r.json(); })
        .then(function (p) { return /\[pre-?order\]|pre-order:/i.test(p.title || '') || (p.tags || []).some(function (t) { t = String(t).toLowerCase(); return t === c.tag || t === 'preorder' || t === 'pre-order'; }); })
        .catch(function () { return false; });
    }
    return tagCache[h];
  }
  function renderCartEta(cart) {
    var box = document.querySelector('[data-lt-cart-eta]'); if (!box) return;
    var c = etaCfg(), items = (cart && cart.items) || [];
    if (!c || !items.length || (cart.currency && cart.currency !== 'SGD')) { box.hidden = true; return; }
    Promise.all(items.map(function (i) { return isPre(i, c); })).then(function (flags) {
      var pre = flags.filter(Boolean).length, msg = box.querySelector('[data-lt-cart-eta-msg]'), wa = box.dataset.wa;
      var link = '<a href="' + wa + '" target="_blank" rel="noopener">WhatsApp us</a>';
      if (!pre) {
        var e = estimate(c);
        msg.innerHTML = 'Estimated delivery (SG): <b>' + rangeStr(e.from, e.to) + '</b><small>' + String(c.disc || '').replace(/[<>&]/g, '') + '</small>';
      } else if (pre < items.length) {
        msg.innerHTML = 'Your cart includes a <b>pre-order</b> item, so your order ships together once it\u2019s ready (see the product page for timing). Need the other items sooner? ' + link;
      } else {
        msg.innerHTML = '<b>Pre-order:</b> ships once ready (see the product page for timing). ' + link + ' for an update.';
      }
      box.hidden = false;
    });
  }
  var recCache = {};
  function renderRecs(cart) {
    var box = document.querySelector('[data-lt-recs]'); if (!box) return;
    var items = cart.items || [];
    if (!items.length) { box.hidden = true; return; }
    var inCart = items.map(function (i) { return i.product_id; });
    var pid = items[0].product_id;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (!recCache[pid]) {
      recCache[pid] = fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
        .then(function (r) { return r.json(); }).then(function (d) { return d.products || []; }).catch(function () { return []; });
    }
    recCache[pid].then(function (list) {
      var fb = []; try { fb = JSON.parse(box.dataset.fallback || '[]'); } catch (e) {}
      var picks = [];
      list.concat(fb).forEach(function (p) {
        if (picks.length < 3 && p.available && inCart.indexOf(p.id) < 0 && !picks.some(function (x) { return x.id === p.id; })) picks.push(p);
      });
      var row = box.querySelector('[data-lt-recs-row]'); row.innerHTML = '';
      picks.forEach(function (p) {
        var a = document.createElement('a'); a.className = 'lt-rec'; a.href = p.url;
        var img = document.createElement('img'); var src = p.featured_image || '';
        if (src && src.indexOf('width=') < 0) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        img.src = src; img.alt = ''; img.decoding = 'async'; img.width = 120; img.height = 120; img.className = 'lt-rec__img';
        var t = document.createElement('span'); t.className = 'lt-rec__t'; t.textContent = String(p.title || '').split('|')[0].replace(/^\s*(Personalised|Personalized|Customised)\s+/i, '').trim();
        var pr = document.createElement('span'); pr.className = 'lt-rec__p'; pr.textContent = money(p.price);
        a.appendChild(img); a.appendChild(t); a.appendChild(pr); row.appendChild(a);
      });
      box.hidden = picks.length === 0;
    });
  }
  var pending;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(update).catch(function () {});
    }, 250);
  }
  document.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart) update(e.detail.cart); else refresh(); });
  ['ajaxProduct:added', 'cart:open', 'cart:build'].forEach(function (ev) { document.addEventListener(ev, refresh); });
  function boot() {
    initSliders();
    renderEta();
    if (document.querySelector('[data-lt-eta]')) setInterval(renderEta, 30000);
    var products = document.querySelector('#CartDrawer [data-products]');
    if (products && window.MutationObserver) new MutationObserver(refresh).observe(products, { childList: true, subtree: true });
    if (document.querySelector('[data-lt-ship],[data-lt-recs],[data-lt-cart-eta]')) refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
})();

/* LIMTEH a11y announcement (6 Oct 2026): hidden announcement slides must not contain focusable links */
(function(){function fix(){document.querySelectorAll('.announcement-slider__slide').forEach(function(s){var h=s.getAttribute('aria-hidden')==='true';s.querySelectorAll('a,button').forEach(function(a){if(h){a.setAttribute('tabindex','-1')}else{a.removeAttribute('tabindex')}})})}function init(){var r=document.getElementById('AnnouncementSlider');fix();if(r&&window.MutationObserver){new MutationObserver(fix).observe(r,{attributes:true,subtree:true,attributeFilter:['aria-hidden']})}}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}})();
